module.exports = __webpack_public_path__ + "img/1.222701f0.png";